export type ApprovalLikelihood = 'marginal' | 'low' | 'moderate' | 'good' | 'high' | 'optimal' | 'veryHigh'

// Conversion-probability model: P(x) = P_MIN + (P_MAX - P_MIN) * (1 - e^(-LAMBDA * x)).
export const CONVERSION_MODEL = {
  P_MIN: 0.3,
  P_MAX: 0.8,
  LAMBDA: 10,
} as const

export const conversionProbability = (contribution: number): number =>
  CONVERSION_MODEL.P_MIN +
  (CONVERSION_MODEL.P_MAX - CONVERSION_MODEL.P_MIN) * (1 - Math.exp(-CONVERSION_MODEL.LAMBDA * contribution))

export const APPROVAL_LIKELIHOOD_TIERS = [
  { threshold: 0, level: 'marginal' },
  { threshold: 0.015, level: 'low' },
  { threshold: 0.03, level: 'moderate' },
  { threshold: 0.05, level: 'good' },
  { threshold: 0.1, level: 'high' },
  { threshold: 0.15, level: 'optimal' },
  { threshold: 0.2, level: 'veryHigh' },
] as const satisfies { threshold: number; level: ApprovalLikelihood }[]

const TIERS_DESCENDING = [...APPROVAL_LIKELIHOOD_TIERS].reverse()

export const getApprovalLikelihood = (contribution: number): ApprovalLikelihood =>
  (TIERS_DESCENDING.find((tier) => contribution >= tier.threshold) ?? APPROVAL_LIKELIHOOD_TIERS[0]).level
